const chineseLocales = new Set(['zh_cn', 'zh_tw']);

export function getBaiAdImagePath(locale, size) {
    const language = chineseLocales.has(locale) ? 'cn' : 'en';
    return `/images/bai/bai-${language}-${size}.png`;
}

export function getBaiAdStyle(locale, size, aspectRatio, extraStyles = {}) {
    return {
        background: `url(${getBaiAdImagePath(locale, size)})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        aspectRatio,
        ...extraStyles,
    };
}
